import { DISCORD_URL } from "@/lib/config";

const Footer = () => {
  return (
    <footer id="discord" data-testid="footer-section" className="py-20 px-6 bg-black text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-display text-5xl md:text-7xl uppercase text-white mb-4">
          Join The Scythe Community
        </h2>
        <p className="text-zinc-400 text-xs max-w-md mx-auto mb-8">
          Access model updates, technical documentation, and receipt verification on Discord.
        </p>
        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-discord-btn"
          className="inline-block px-10 py-4 bg-[#ff4655] hover:bg-white hover:text-black text-white font-extrabold uppercase text-xs tracking-widest transition-colors skew-x-[-8deg]"
        >
          <span className="inline-block skew-x-[8deg]">Open Discord</span>
        </a>
        <div className="mt-16 pt-6 border-t border-zinc-900 flex justify-between text-[10px] font-mono-x text-zinc-600">
          <span>© SCYTHE PRODUCTS</span>
          <span>DIGITAL SOFTWARE ONLY</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
